/**
 * ⚠️ AUTO-GENERATED FILE - DO NOT EDIT
 *
 * Generated by: sf database-code
 * Generated from database schema
 *
 * To modify: Change the database schema and re-run `sf database-code` (dc). To make a column queryable by index — including boolean/nullable columns — add a single-column Postgres index and re-run `sf dc`; do not hand-edit generated files.
 */
/* eslint-disable @typescript-eslint/array-type -- the generated interface uses (T | null)[] for accurate array element nullability */
/* eslint-disable complexity -- the generated converters branch per column; complexity scales with column count */
import { isObject, hasPropOfType, isArrayOfType, UUID, Temporal, type LocalDatabaseTableDefinition } from 'sf-shared';
import type { UnambiguationBase } from 'shared/dbo/Unambiguation';

export interface UnambiguationIndexedDb {
	id: string;
	consumablePath: (string | null)[];
	chosenOption?: string;
	chosenOption__is_null: number;
	choiceDate?: string;
	choiceDate__is_null: number;
	wholePathOnly: number;
	created: number;
	lastModified: number;
	shortId: string;
}

export const isUnambiguationIndexedDb = (obj: unknown): obj is UnambiguationIndexedDb => {
	if (!isObject(obj)) {
		return false;
	}
	if (hasPropOfType<{ deleted: boolean }>(obj, 'deleted', 'boolean') && obj.deleted) {
		return true;
	}
	if (!hasPropOfType<{ id: unknown }>(obj, 'id') || !(typeof obj.id === 'string')) {
		return false;
	}
	if (!hasPropOfType<{ consumablePath: unknown }>(obj, 'consumablePath') || !(Array.isArray(obj.consumablePath) && isArrayOfType(obj.consumablePath, (el: unknown): el is string | null => typeof el === 'string' || el === null))) {
		return false;
	}
	if (hasPropOfType<{ chosenOption: unknown }>(obj, 'chosenOption') && !(typeof obj.chosenOption === 'string')) {
		return false;
	}
	if (!hasPropOfType<{ chosenOption__is_null: unknown }>(obj, 'chosenOption__is_null') || !(typeof obj.chosenOption__is_null === 'number')) {
		return false;
	}
	if (hasPropOfType<{ choiceDate: unknown }>(obj, 'choiceDate') && !(typeof obj.choiceDate === 'string')) {
		return false;
	}
	if (!hasPropOfType<{ choiceDate__is_null: unknown }>(obj, 'choiceDate__is_null') || !(typeof obj.choiceDate__is_null === 'number')) {
		return false;
	}
	if (!hasPropOfType<{ wholePathOnly: unknown }>(obj, 'wholePathOnly') || !(typeof obj.wholePathOnly === 'number')) {
		return false;
	}
	if (!hasPropOfType<{ created: unknown }>(obj, 'created') || !(typeof obj.created === 'number')) {
		return false;
	}
	if (!hasPropOfType<{ lastModified: unknown }>(obj, 'lastModified') || !(typeof obj.lastModified === 'number')) {
		return false;
	}
	if (!hasPropOfType<{ shortId: unknown }>(obj, 'shortId') || !(typeof obj.shortId === 'string')) {
		return false;
	}
	return true;
};

export const baseToIndexedDB = (obj: UnambiguationBase): UnambiguationIndexedDb => ({
	id: obj.id.toString(),
	// prettier-ignore
	// eslint-disable-next-line no-eq-null, eqeqeq -- generated: intentional null|undefined (== null) runtime check for the nullable cache form; see #129
	consumablePath: obj.consumablePath.map(tval => tval == null ? tval : tval.toString()),
	// prettier-ignore
	// eslint-disable-next-line no-eq-null, eqeqeq -- generated: intentional null|undefined (== null) runtime check for the nullable cache form; see #129
	chosenOption: obj.chosenOption == null ? undefined : obj.chosenOption.toString(),
	// prettier-ignore
	// eslint-disable-next-line no-eq-null, eqeqeq -- generated: intentional null|undefined (== null) runtime check for the nullable cache form; see #129
	chosenOption__is_null: obj.chosenOption == null ? 1 : 0,
	// prettier-ignore
	// eslint-disable-next-line no-eq-null, eqeqeq -- generated: intentional null|undefined (== null) runtime check for the nullable cache form; see #129
	choiceDate: obj.choiceDate == null ? undefined : obj.choiceDate.toString(),
	// prettier-ignore
	// eslint-disable-next-line no-eq-null, eqeqeq -- generated: intentional null|undefined (== null) runtime check for the nullable cache form; see #129
	choiceDate__is_null: obj.choiceDate == null ? 1 : 0,
	wholePathOnly: obj.wholePathOnly ? 1 : 0,
	created: obj.created.epochMilliseconds,
	lastModified: obj.lastModified.epochMilliseconds,
	shortId: obj.id.shortString,
});

export const indexedDBToBase = (obj: UnambiguationIndexedDb): UnambiguationBase => ({
	id: UUID.fromString(obj.id),
	// prettier-ignore
	// eslint-disable-next-line no-eq-null, eqeqeq -- generated: intentional null|undefined (== null) runtime check for the nullable cache form; see #129
	consumablePath: obj.consumablePath.map(tval => tval == null ? tval : UUID.fromString(tval)),
	// prettier-ignore
	// eslint-disable-next-line no-eq-null, eqeqeq -- generated: intentional null|undefined (== null) runtime check for the nullable cache form; see #129
	chosenOption: obj.chosenOption == null ? undefined : UUID.fromString(obj.chosenOption),
	// prettier-ignore
	// eslint-disable-next-line no-eq-null, eqeqeq -- generated: intentional null|undefined (== null) runtime check for the nullable cache form; see #129
	choiceDate: obj.choiceDate == null ? undefined : Temporal.PlainDate.from(obj.choiceDate),
	wholePathOnly: obj.wholePathOnly === 1,
	created: Temporal.Instant.fromEpochMilliseconds(obj.created),
	lastModified: Temporal.Instant.fromEpochMilliseconds(obj.lastModified),
	objectContext: 'db',
});

export const itdUnambiguation: LocalDatabaseTableDefinition<UnambiguationBase, UnambiguationIndexedDb> = {
	tableName: 'unambiguations',
	indexColumns: ['consumablePath', 'chosenOption', 'choiceDate', 'chosenOption__is_null', 'choiceDate__is_null'],
	convertToIndexed: baseToIndexedDB,
	convertFromIndexed: indexedDBToBase,
};
